"use client";
import { useState, useEffect, useRef } from "react";

export default function FilterDropdown({ activeFilter, filters, onFilterChange, label }) {
	const [isOpen, setIsOpen] = useState(false);
	const [isClosing, setIsClosing] = useState(false);
	const dropdownRef = useRef(null);

	const toggleDropdown = () => {
		if (isOpen) {
			closeDropdown();
		} else {
			setIsOpen(true);
		}
	};

	const closeDropdown = () => {
		setIsClosing(true);
		setTimeout(() => {
			setIsOpen(false);
			setIsClosing(false);
		}, 300);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				closeDropdown();
			}
		};

		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isOpen]);

	const handleSelect = (value, disabled) => {
		if (disabled) return;
		onFilterChange(value);
		closeDropdown();
	};

	const activeFilterData = filters.find((f) => f.value === activeFilter);
	const valueLabel = activeFilterData ? `${activeFilterData.label}` : "";
	const hasActiveFilter = activeFilter !== null;

	const handleReset = () => {
		onFilterChange(null);
	};

	return (
		<div className={`filter-item ${isOpen && !isClosing ? "is-open" : ""} ${isClosing ? "is-closing" : ""}`} ref={dropdownRef}>
			
			<button className="dropdown-trigger" onClick={toggleDropdown} aria-expanded={isOpen} aria-haspopup="true">
				<span className="dropdown-label">{label}</span>
				<span className="dropdown-value">{valueLabel}</span>
				<svg viewBox="0 0 50 50" className="dropdown-arrow">
					<path d="M45.92,6.6H4.08c-2.73,0-4.37,3.01-2.9,5.31l20.92,32.62c1.36,2.11,4.45,2.11,5.80,0L48.82,11.91c1.47-2.29-.18-5.31-2.9-5.31Z" />
				</svg>
			</button>
			{hasActiveFilter && (
				<button className="dropdown-reset" onClick={handleReset} aria-label="Réinitialiser le filtre">
					✕
				</button>
			)}
			<div className="dropdown-menu" role="menu" aria-hidden={!isOpen}>
				{filters.map((filter, index) => (
					<div className="dropdown-item-wrapper" key={filter.value ?? `all-${index}`}>
						<button
							className={`dropdown-item ${activeFilter === filter.value ? "active" : ""} ${filter.disabled ? "disabled" : ""}`}
							onClick={() => handleSelect(filter.value, filter.disabled)}
							role="menuitem"
							tabIndex={isOpen ? 0 : -1}
							disabled={filter.disabled}
						>
							{filter.label}
						</button>
					</div>
				))}
			</div>
		</div>
	);
}
